'use client';

import { useIndicatorStore } from '@/stores/indicatorStore';
import Indicator from '../molecules/Indicator';

export default function IndicatorContainer() {
  const { isVisible, message, subMessage } = useIndicatorStore();

  return (
    <Indicator isOpen={isVisible} message={message} subMessage={subMessage} />
  );
}
